import { Fragment } from "react";
import "./Sidebar.styles.scss";
import { useRouter } from "src/hooks/useRouter";
import { useTranslation } from "react-i18next";

interface ISidebarUIProps {
  path?: any;
  goConsole?: any;
  goBill?: any;
}
const SidebarUI = (props: ISidebarUIProps) => {
  const { path, goConsole, goBill } = props;
  const { goMyAccount } = useRouter();
  const { t } = useTranslation();
  // const { isCashApply } = useIsCashApply();
  // const initialSelectedIndex = options.findIndex(
  //   ({ value }) => value === product
  // );
  // console.log("navStep", navStep);
  return (
    <Fragment>
      {(path === "console" ||
        // (path === "console" && navStep !== 1 && navStep !== 2) ||
        path === "bill") && (
        <nav className={`leftNav`}>
          <ul className="leftNav-menu">
            <li className={`site_mgnt ${path === "console" ? "active" : ""}`}>
              <a onClick={goConsole}>{t("navBar.leftMenu.siteManagement")}</a>
            </li>
            <li className={`bill_history ${path === "bill" ? "active" : ""}`}>
              <a onClick={goBill}>{t("navBar.leftMenu.paymentHistory")}</a>
            </li>
          </ul>

          <p className="leftBottom">
            <span className="companyName">
              {"© Fasoo"}
              {/* {'© ' + moment().format('YYYY') + ' Fasoo'} */}
              {/* {t('navBar.companyName')} */}
            </span>
          </p>
        </nav>
      )}
      {path === "my-account" && (
        <nav className={`leftNav`}>
          <ul className="leftNav-menu">
            <li className={`site_mgnt ${path === "console" ? "active" : ""}`}>
              <a onClick={goConsole}>{t("navBar.leftMenu.siteManagement")}</a>
            </li>
            <li className={`bill_history ${path === "bill" ? "active" : ""}`}>
              <a onClick={goBill}>{t("navBar.leftMenu.paymentHistory")}</a>
            </li>
          </ul>

          <p className="leftBottom">
            <span className="companyName">{"© Fasoo"}</span>
          </p>
        </nav>
      )}
    </Fragment>
  );
};

export default SidebarUI;
